import { useCallback, useState } from 'react';
import { BoutiqueCalendarLayoutEvent, BoutiqueEventPopoverState } from '../boutique-calendar.types';

export function useBoutiqueEventPopover() {
	const [popoverState, setPopoverState] = useState<BoutiqueEventPopoverState | null>(null);

	const onOpenPopover = useCallback((event: BoutiqueCalendarLayoutEvent, anchorElement: HTMLElement): void => {
		setPopoverState(currentState => (currentState?.event?.id === event?.id ? null : { event, anchorElement }));
	}, []);

	const onClosePopover = useCallback((): void => setPopoverState(null), []);

	return { popoverState, onOpenPopover, onClosePopover };
}
